import {importProvidersFrom, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {AppComponent} from './app.component';
import {appRoutes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {
    HTTP_INTERCEPTORS,
    HttpClientModule,
    provideHttpClient,
    withInterceptorsFromDi
} from '@angular/common/http';
import {
    AuthInterceptor,
    ErrorInterceptor,
    TokenService
} from './shared';
import {
    NgxUiLoaderConfig,
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule,
    POSITION,
    SPINNER
} from 'ngx-ui-loader';
import {JwtModule} from '@auth0/angular-jwt';
import {provideToastr} from 'ngx-toastr';
import {FileSaverModule} from 'ngx-filesaver';
import {registerLocaleData} from '@angular/common';
import localeZA from '@angular/common/locales/en-ZA';
import {RedirectComponent} from './redirect/redirect.component';
import {DocumentViewerModalComponent} from "./shared/components/document-viewer-modal/document-viewer-modal.component";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export function tokenGetter(): string | null {
    return TokenService.TOKEN;
}

registerLocaleData(localeZA);


const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsColor: '#ff0000',
    bgsOpacity: 0.5,
    bgsPosition: POSITION.bottomCenter,
    bgsSize: 60,
    blur: 5,
    fgsColor: '#8cd436',
    fgsPosition: POSITION.centerCenter,
    fgsSize: 70,
    //threeStrings,ballScaleMultiple,chasingDots
    fgsType: SPINNER.threeStrings, // ✅ Use SPINNER enum
    hasProgressBar: true,
    pbColor: '#8cd436',
    pbThickness: 3,
    text: 'Loading....',
    textColor: '#A2A3A3',
    textPosition: POSITION.centerCenter
};

@NgModule({
    declarations: [
        AppComponent,
        RedirectComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, {bindToComponentInputs: true}),
        NgxUiLoaderModule,
        NgxUiLoaderRouterModule,
        HttpClientModule,
        JwtModule.forRoot({
            config: {tokenGetter: tokenGetter, skipWhenExpired: true}
        }),
        FileSaverModule,
        DocumentViewerModalComponent,
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'en-ZA'},
        provideAnimationsAsync(),
        provideToastr(),
        provideHttpClient(withInterceptorsFromDi()),
        ErrorInterceptor,
        {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        importProvidersFrom(
            NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
        ),
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
